"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _propTypes2 = _interopRequireDefault(require("@styled-system/prop-types"));

var _formField = _interopRequireWildcard(require("./form-field.style"));

var _label = _interopRequireDefault(require("../label"));

var _fieldHelp = _interopRequireDefault(require("../field-help"));

var _tags = _interopRequireDefault(require("../../utils/helpers/tags"));

var _tab = require("../../components/tabs/tab");

var _useIsAboveBreakpoint = _interopRequireDefault(require("../../hooks/__internal__/useIsAboveBreakpoint"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const FormField = ({
  children,
  disabled,
  fieldHelp,
  fieldHelpInline,
  error,
  warning,
  info,
  helpId,
  helpTag,
  helpTabIndex,
  label,
  labelId,
  labelAlign,
  labelHelp,
  labelHelpIcon,
  labelInline,
  labelSpacing = 2,
  labelWidth,
  name,
  id,
  reverse,
  childOfForm,
  isOptional,
  readOnly,
  useValidationIcon,
  adaptiveLabelBreakpoint,
  isRequired,
  ...rest
}) => {
  const context = (0, _react.useContext)(_tab.TabContext);
  const largeScreen = (0, _useIsAboveBreakpoint.default)(adaptiveLabelBreakpoint);
  let inlineLabel = labelInline;

  if (adaptiveLabelBreakpoint) {
    inlineLabel = largeScreen;
  }

  (0, _react.useEffect)(() => {
    if (context && context.setError && context.setWarning && context.setInfo) {
      context.setError(id, !!error);
      context.setWarning(id, !!warning);
      context.setInfo(id, !!info);
    }
  }, [id, context, error, warning, info]); // Conditionally add the spacing props, we can't spread ...rest because some of the parent components
  // incorrectly pass props that are consumed in other components.
  //
  // The styled-system/space props need to be conditional, a undefined value is still considered a value and affects the
  // the behaviour
  //
  // FIXME FE-3370

  const spacingProps = ["m", "margin", "ml", "marginLeft", "mr", "marginRight", "mt", "marginTop", "mb", "marginBottom", "mx", "marginLeft", "mx", "marginRight", "my", "marginTop", "my", "marginBottom", "p", "padding", "pl", "paddingLeft", "pr", "paddingRight", "pt", "paddingTop", "pb", "paddingBottom", "px", "paddingLeft", "px", "paddingRight", "py", "paddingTop", "py", "paddingBottom"].reduce((prev, curr) => {
    if (Object.prototype.hasOwnProperty.call(rest, curr)) {
      prev[curr] = rest[curr];
    }

    return prev;
  }, {});
  return /*#__PURE__*/_react.default.createElement(_formField.default, _extends({}, (0, _tags.default)(rest["data-component"], rest), spacingProps), /*#__PURE__*/_react.default.createElement(_formField.FieldLineStyle, {
    inline: inlineLabel
  }, reverse && children, label && /*#__PURE__*/_react.default.createElement(_label.default, {
    labelId: labelId,
    align: labelAlign,
    disabled: disabled,
    readOnly: readOnly,
    error: error,
    warning: warning,
    info: info,
    help: labelHelp,
    helpId: helpId,
    helpTag: helpTag,
    helpTabIndex: helpTabIndex,
    htmlFor: id,
    helpIcon: labelHelpIcon,
    inline: inlineLabel,
    width: labelWidth,
    childOfForm: childOfForm,
    optional: isOptional,
    useValidationIcon: useValidationIcon,
    pr: !reverse ? labelSpacing : undefined,
    pl: reverse ? labelSpacing : undefined,
    isRequired: isRequired
  }, label), fieldHelp && fieldHelpInline && /*#__PURE__*/_react.default.createElement(_fieldHelp.default, {
    labelInline: inlineLabel,
    labelWidth: labelWidth
  }, fieldHelp), !reverse && children), fieldHelp && !fieldHelpInline && /*#__PURE__*/_react.default.createElement(_fieldHelp.default, {
    labelInline: inlineLabel,
    labelWidth: labelWidth
  }, fieldHelp));
};

const errorPropType = (props, propName, componentName, ...rest) => {
  if (props[propName] && props.disabled) {
    return new Error(`Prop \`${propName}\` cannot be used in conjunction with \`disabled\`. ` + "Use `readOnly` if you require users to see validations with a non-interactive field");
  }

  return _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string])(props, propName, componentName, ...rest);
};

FormField.propTypes = {
  /** Styled system spacing props */
  ..._propTypes2.default.space,
  children: _propTypes.default.node,
  childOfForm: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  "data-component": _propTypes.default.string,
  fieldHelp: _propTypes.default.node,
  fieldHelpInline: _propTypes.default.bool,
  error: errorPropType,
  warning: errorPropType,
  info: errorPropType,
  helpId: _propTypes.default.string,
  helpTag: _propTypes.default.string,
  helpTabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  id: _propTypes.default.string.isRequired,
  name: _propTypes.default.string,
  isOptional: _propTypes.default.bool,
  label: _propTypes.default.node,
  labelId: _propTypes.default.string,
  labelAlign: _propTypes.default.oneOf(["left", "right"]),
  labelHelp: _propTypes.default.node,
  labelHelpIcon: _propTypes.default.string,
  labelInline: _propTypes.default.bool,

  /** Spacing between label and a field for inline label, given number will be multiplied by base spacing unit (8) */
  labelSpacing: _propTypes.default.oneOf([1, 2]),
  labelWidth: _propTypes.default.number,
  readOnly: _propTypes.default.bool,
  reverse: _propTypes.default.bool,
  useValidationIcon: _propTypes.default.bool,

  /** Breakpoint for adaptive label (inline labels change to top aligned). Enables the adaptive behaviour when set */
  adaptiveLabelBreakpoint: _propTypes.default.number,

  /** Flag to configure component as mandatory */
  isRequired: _propTypes.default.bool
};
var _default = FormField;
exports.default = _default;